<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <title>pause</title>
        <path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zM10 10h4v12h-4zM18 10h4v12h-4z"></path>
    </svg>
</template>

<script>
export default {
    name: "PauseVideo",
};
</script>

<style scoped>
svg {
    width: 150px;
    height: auto;
    fill: #757575;
}
</style>
